import log from "./logger/log";
import { setOperations } from "../state/ducks/operations";
import { httpClient } from "./httpClient";
import { dispatch, getState } from "../state/store";
import {api} from '../constants/operations_api';
import {selectOperationsFilter} from "../state/selectors/operations";


const getOperations = async (filter, token) => {
    let canceled;
    token = token ? token : {};
    token.cancel = () => {
        canceled = true;
    }

    const url = api.GET_OPERATIONS_LIST_API;
    
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }

    try {
        if(canceled) {
            throw new Error("canceled");
        };

        const data = await httpClient.post(url, postData);
        let operations = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        if(canceled) {
            throw new Error("canceled");
        };

        dispatch(setOperations(operations.items, operations.filter));
    }
    catch (error) {
        if(error.message === 'canceled') {
            log.debug(error.message);
            return null;
        }

        log.error(JSON.stringify(error));
    }
};

const getReport = async (filter) => {
    const url = api.GET_OPERATIONS_REPORT_API;

    // const filter = selectOperationsFilter()(getState());
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }

    try {
        const response = await httpClient.getReport("POST", url, postData);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
}

const operationsService = {
    getOperations,
    getReport
}

export default operationsService;